module.exports = __webpack_public_path__ + "static/img/geotap-game-lucre-games-focus-mode-mobile.457f09f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/geotap-game/geotap-game-lucre-games-focus-mode-mobile.jpg
// module id = kVHJ
// module chunks = 0